export const MARKETING_LAYOUT_TITLE = 'marketingLayout-title';
export const MARKETING_LAYOUT_DESCRIPTION = 'marketingLayout-description';
